import type { Spell } from '@/schemas/spell';
import type { SpellCardTag } from './SpellCard';

/**
 * Produce la lista di tag pill da renderizzare per uno SpellCard.
 * Variant `lvl-0`/`lvl-1` dal livello dello spell; variant `auto`/`pick`/`picked`
 * dallo stato. Tag aggiuntivi raw (es. "continuato") come variant `state`.
 *
 * Estratto in file separato per rispettare `react-refresh/only-export-components`
 * (SpellCard.tsx esporta solo componenti).
 */
export function spellTagsForCard(spell: Spell, state: 'auto' | 'pick' | 'picked'): SpellCardTag[] {
  const tags: SpellCardTag[] = [];
  tags.push({
    label: spell.level === 0 ? 'LV 0' : `LV ${spell.level}`,
    variant: spell.level === 0 ? 'lvl-0' : 'lvl-1',
  });
  tags.push({ label: stateLabel(state), variant: state });
  if (spell.tags.includes('continuato')) {
    tags.push({ label: 'continuato', variant: 'state' });
  }
  return tags;
}

function stateLabel(state: 'auto' | 'pick' | 'picked'): string {
  if (state === 'auto') return 'AUTO';
  if (state === 'picked') return 'SCELTO';
  return 'SCEGLI';
}
